import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ModalBody, ModalHeader, ModalService, injectModalData } from '../../../shared/modal';

export interface HelpSheetData {
  title: string;
  /** The rows the page already renders in its desktop dropdown, so the copy
   *  lives in one place. */
  content: TemplateRef<unknown>;
  /** Extra class next to .operators-help, e.g. 'question-tips'. */
  panelClass?: string;
}

/** Phone version of a help dropdown (query tips, Boolean operators): the
 *  same rows in a bottom sheet instead of a popover hanging off the link. */
@Component({
  selector: 'app-help-sheet',
  standalone: true,
  imports: [ModalHeader, ModalBody, NgTemplateOutlet],
  template: `
    <app-modal-header [title]="data.title" />
    <app-modal-body>
      <div class="operators-help operators-help--sheet" [class]="data.panelClass ?? ''">
        <ng-container [ngTemplateOutlet]="data.content" />
      </div>
    </app-modal-body>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpSheet {
  readonly data = injectModalData<HelpSheetData>();
}

export function openHelpSheet(modalService: ModalService, data: HelpSheetData): void {
  modalService.medium(HelpSheet, { data });
}
